import { createStyles } from '@material-ui/styles';

const styles = (): any =>
    createStyles({
        subFormDetails: {
            width: '40%',
        },
    });

export default styles;
